import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import SearchForm from './SearchForm';

export default class Staffs extends Component {

    constructor(props) {
        super(props)
        this.state = {
            staffs: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            prefs: [],
            from: '',
            to: '',
            total: '',
        }
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }
    
    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/staffs/search', key).then(response => {
            this.setState({
                staffs: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
    }
    
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
        }

        // get prefectures
        axios.get('/api/prefs').then(response => {
            this.setState({
                prefs: response.data
            })
        })
        
        //always get list data
        axios.post('/api/staffs/search', keySearch_arr).then(response => {
            this.setState({
                staffs: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
    }
    
    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/staffs/search', newSearchConditions).then(response => {
            this.setState({
                staffs: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }
    
    /**
     * Edit staff
     * staff: Object Staff
     */
    handleEdit(staff) {
        this.props.history.push('/staffs/edit/' + staff.id);
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render() {
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text'},
            {name: 'firstlast', title: '名前', isSort: 1, type: 'text_limit', isSearch:true},
            {name: 'nickname', title: 'ニックネーム', isSort: 1, type: 'text_limit', isSearch:true},
            {name: 'email', title: 'メールアドレス', isSort: 1, type: 'text_limit', isSearch:true},
            {name: 'tel', title: '電話番号', isSort: 0, type: 'text', isSearch:true},
            {name: 'gender', title: '性別', isSort: 1, type: 'gender'},
            {name: 'birthday', title: '年齢', isSort: 1, type: 'age', prefix:'', suffix:'歳'},
            {name: 'pref_name', title: '都道府県', isSort: 0, type: 'text', isSearch:true},
            {name: 'status', title: 'ステータス', isSort: 1, type: 'option', option:{1:{text:'承認',classHTML:'text-teal'},9:{text:'否認',classHTML:'text-pink'},0:{text:'未承認',classHTML:'text-gray'},null:{text:'未承認',classHTML:'text-gray'},8:{text:'停止',classHTML:'text-warning'} }},
            {name: 'created_at', title: '登録日', isSort: 1, type: 'date'},
            {name: 'job_apply_count', title: '応募数', isSort: 1, type: 'text'},
            {name: 'evaluation_avg', title: '平均評価', isSort: 1, type: 'truncate', truncateLength: 4},
        ]
        
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">ワーカー一覧</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">ワーカー一覧</h4>
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search_staff" aria-expanded="false" aria-controls="search_staff">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm prefs={this.state.prefs} onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                                <Table onSearch={this.handleSearch} onEdit={this.handleEdit} header={columns} data={this.state.staffs} onSort={this.handleSort} from={this.state.from} to={this.state.to} total={this.state.total}
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} />
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        );
    }
}
